export default __webpack_public_path__ + "static/media/rn.571fa743.png";